import { Stack, Typography } from "@mui/material";
import { UListItemButton } from "../common/ui.buttons";
import { CPage, CPageTop, CSection } from "../components/cr.ui.page";
import { usePlayer } from "../components/player";
import { useExtTwar } from "../components/ext.twar";
import { UIcon } from "../common/ui.icon";


export function PExtTwarAllianceSelectPage() {
    const player = usePlayer();
    const crusade = player.crusade;

    return <CPage>
        <CPageTop secondary="Nuovo giocatore" primary="Selezione alleanza" />
        <CSection>
            {crusade.alliances.map(a => <AllianceSelect key={a.id} all={a} />)}
        </CSection>
    </CPage>
}

function AllianceSelect(props) {
    const { all } = props;
    const twar = useExtTwar();

    return <UListItemButton onClick={() => twar.joinAlliance(all.id)} sx={{
        justifyContent: 'center',
        flexDirection: 'column',
        padding: 6
    }}>
        <UIcon name={all.icon} size={64} />
        <Typography sx={{
            fontSize: 24,
            fontWeight: 500,
        }}>{all.name}</Typography>
        <Typography>{all.description}</Typography>
    </UListItemButton>
}